export default __webpack_public_path__ + "static/media/ConfirmStartWebinarModal.6a671768.svg";